module.exports = __webpack_public_path__ + "img/bj_tianjia.4e0bf21c.png";